import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import Information from "./_information";
import { FormProvider, useForm } from "react-hook-form";
import { TenantForm } from "@/types/tenant.type";
import { useAddTenantMutation } from "@/services/tenant.service";

export default function AddTenant() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const {state: {fromModal, id}} = useLocation()
    const [addTenant, {isSuccess, data: tenant}] = useAddTenantMutation()
    const methods = useForm<TenantForm>()
    const {handleSubmit} = methods

    const onSubmit = handleSubmit((data) => {
        addTenant({...data, gender: Number(data.gender)})
    })

    const closeModal = () => {
        if (_.isEmpty(fromModal)) {
            navigate(location, {state: {reload: true}})
        } else {
            navigate(location, {state: {tenant_id: tenant?.id || '', id: id, modal: fromModal}})
        }
    }

    useEffect(() => {
        if(isSuccess) {
            closeModal()
        }
    }, [isSuccess])

    return (
        <div x-show="modalOpen" x-transition="" className="fixed top-0 left-0 z-99999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5">
            <div className="w-full max-w-screen-sm rounded-lg bg-white py-5 px-8 dark:bg-boxdark">
                <h3 className="text-xl dark:text-white text-center font-medium my-5">
                    {t("tenant.add")}
                </h3>
                <form className="mx-5" onSubmit={onSubmit}>
                    <FormProvider {...methods}>
                        <Information />
                    </FormProvider>
                    <div className="flex justify-end">
                        <div className="px-3">
                            <button type="button" onClick={closeModal} className="block w-full rounded border border-stroke bg-gray-400 p-1.5 px-3 text-center font-medium text-black transition hover:bg-opacity-90">
                                {t("modal.cancel")}
                            </button>
                        </div>
                        <div className="px-3">
                            <button type="submit" className="flex w-full justify-center rounded bg-primary p-1.5 px-3 text-white hover:bg-opacity-90">
                                {t("modal.submit")}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
